import queryString from 'query-string';
import { createSearchParams } from 'react-router-dom';

export type ToType = string | Partial<{
  pathname: string;
  search: string;
  hash: string;
}>;

type MixCustomizationParamType = (to: ToType, customizationParam?: string | null) => ToType;

const mixCustomizationParam: MixCustomizationParamType = (to, customizationParam) => {
  if (!customizationParam) {
    return to;
  }
  
  if (typeof to === 'string') {
    const toUrl = new URL(to, window.location.origin);
    const search = queryString.parse(toUrl.search) || {};
    const mixedSearch = { ...search, customization: customizationParam };
    return { pathname: toUrl.pathname, search: createSearchParams(mixedSearch).toString() };
  }
  
  if (!to.search) {
    return { ...to, search: `customization=${customizationParam}` };
  }
  
  const search: any = queryString.parse(to.search);
  
  if (search.customization) {
    return to;
  }
  
  search.customization = customizationParam;
  
  return { ...to, search: createSearchParams(search).toString() };
}

export default mixCustomizationParam;